import crud from "../crud";

interface BaseAgreement {
  number: string;
  offices: Array<{ officeId: number; price: number }>;
  renterId: number;
  price: number;
  description: string;
  startDate: string;
  endDate: string;
  deposit: number | null;
  requisiteId: number | null;
  renterRequisiteId: number | null;
  meetingHours: number;
  scan?: string;
}

export interface Agreement extends BaseAgreement {
  id: number;
  isActive: boolean;
  officeDisplayName: string;
}

export type AgreementCreate = Omit<BaseAgreement, "price">;
export type AgreementUpdate = Omit<BaseAgreement, "price">;

export function AgreementsAPI(baseUrl: string) {
  return {
    list: async () => {
      return (await crud.get(
        `${baseUrl}/agreements`,
        undefined,
        true,
      )) as Agreement[];
    },
    get: async (id: number) => {
      return (await crud.get(
        `${baseUrl}/agreements/${id}`,
        undefined,
        true,
      )) as Agreement;
    },
    create: async (rentedOfficeData: AgreementCreate) => {
      return (await crud.post(
        `${baseUrl}/agreements`,
        rentedOfficeData,
        true,
      )) as Agreement;
    },
    update: async (id: number, rentedOfficeData: AgreementUpdate) => {
      return (await crud.patch(
        `${baseUrl}/agreements/${id}`,
        rentedOfficeData,
        true,
      )) as Agreement;
    },
    delete: async (id: number) => {
      return (await crud.delete(
        `${baseUrl}/agreements/${id}`,
        true,
      )) as Agreement;
    },
  };
}
